<template>
	<div class="card shadow-sm border rounded-lg p-4 bg-white mail-detail-card">
        <div class="mb-3 pb-3 border-bottom d-flex align-items-start justify-content-between">
            <div>
                <h5 class="mb-2 font-weight-bold text-dark" style="font-size: 1.25rem;">{{msgContent.subject}}</h5>
                <div class="d-flex align-items-center text-muted small mt-1">
                    <span v-if="msgContent.is_lock == 1" class="badge badge-pill badge-light border text-muted px-2 py-1 mr-2">
                        <i class="ri-lock-fill mr-1"></i>{{$t('message_lock')}}
                    </span>
                    <span v-if="msgContent.is_lock == 0" class="badge badge-pill border px-2 py-1 mr-2 text-success" style="background-color: #ecfdf5; border-color: #a7f3d0 !important;">
                        <i class="ri-lock-unlock-line mr-1"></i>{{$t('message_unlock')}}
                    </span>
                    <span class="text-muted"><i class="ri-time-line mr-1"></i>{{msgContent.updated_at}}</span>
                </div>
            </div>
            <b-button @click="goBack" variant="light" class="btn-icon rounded-circle shadow-sm border" title="Geri">
                <i class="ri-arrow-go-back-line h5 mb-0"></i>
            </b-button>
        </div>

        <div class="mail-header-info rounded p-3 mb-4 d-flex align-items-center justify-content-between border" style="background-color: #f8fafc;">
            <div class="d-flex align-items-center">
                <div class="avatar-circle mr-3 d-flex justify-content-center align-items-center font-weight-bold rounded-circle text-white shadow-sm flex-shrink-0"
                     style="background: linear-gradient(135deg, #2563eb, #1d4ed8); width: 44px; height: 44px; font-size: 16px;">
                    <i class="ri-user-3-line"></i>
                </div>
                <div>
                    <div class="font-weight-bold text-dark mb-1" style="font-size: 15px;">{{msgContent.sender}}</div>
                    <div class="small text-muted">
                        <span class="mr-2"><b>{{$t('to')}}:</b> {{msgContent.to}}</span>
                    </div>
                </div>
            </div>
            <div class="text-right small text-muted d-none d-sm-block">
                {{msgContent.updated_at}}
            </div>
        </div>

        <div class="mail-body-box mb-4 p-4 rounded border" style="background-color: #ffffff; min-height: 120px; font-size: 15px; line-height: 1.6; color: #334155;">
            <div v-html="decodeHtml(msgContent.message)"></div>
        </div>

        <div v-for="(itm, key) in msgContent.messages" :key="key" class="reply-card border-left pl-4 mb-4 py-3 pr-3 rounded-right border-top border-right border-bottom" style="border-left: 4px solid #2563eb !important; background-color: #f8fafc;">
            <div class="d-flex align-items-center justify-content-between mb-2">
                <div class="font-weight-bold text-dark"><i class="ri-reply-line mr-1 text-primary"></i> {{itm.sender}}</div>
                <div class="small text-muted">{{formatDate(itm.updated_at)}}</div>
            </div>
            <div class="small text-muted mb-2"><b>{{$t('to')}}:</b> {{itm.to}}</div>
            <div class="text-secondary" v-html="decodeHtml(itm.message)"></div>
        </div>

        <div v-if="msgContent.files && msgContent.files.length" class="mb-4">
            <h6 class="font-weight-bold text-muted mb-3" style="font-size: 13px; text-transform: uppercase; letter-spacing: 0.5px;"><i class="ri-attachment-2 mr-1"></i> {{ $t('attached_files') }}</h6>
            <div class="d-flex flex-wrap">
                <div
                    v-for="(itm, key) in msgContent.files"
                    :key="key"
                    class="attachment-card p-3 rounded border bg-white shadow-sm d-flex align-items-center mr-3 mb-2 cursor-pointer transition-all"
                    @click="downloadFile(itm)">
                    <div class="mr-3 p-2 bg-light text-primary rounded-circle">
                        <i class="ri-file-text-line h4 mb-0"></i>
                    </div>
                    <div>
                        <div class="font-weight-bold text-dark small text-truncate" style="max-width: 180px;">{{itm.name}}</div>
                        <div class="text-primary small font-weight-medium mt-1"><i class="ri-download-2-line mr-1"></i>{{$t('download')}}</div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="msgEditorShow" class="border rounded p-4 mb-4 bg-white shadow-sm">
            <ValidationObserver ref="answerForm">
                <ValidationProvider name="message" rules="required" v-slot="{valid, errors}">
                    <b-form-group :label="$t('answer')" class="font-weight-bold">
                        <ck-editor-input
                            v-model="answerMsg"
                            :validateError="errors[0]"/>
                    </b-form-group>
                </ValidationProvider>
                <b-button @click="sendAnswer" class="mt-3 px-4 shadow-sm" variant="primary">
                    <i class="ri-send-plane-fill mr-1"></i> {{$t('send')}}
                </b-button>
            </ValidationObserver>
        </div>

        <div class="d-flex align-items-center justify-content-between pt-3 border-top">
            <b-button
                v-if="msgContent.is_lock == 0"
                @click="showEditor"
                type="submit"
                variant="outline-primary"
                class="px-4 shadow-sm">
                <i class="ri-reply-line mr-1"></i> {{msgEditorShow ? $t('cancel') : $t('answer_force')}}
            </b-button>
            <b-button
                v-if="msgContent.user_id == user.id"
                @click="deleteMessage"
                type="submit"
                variant="outline-danger"
                class="px-4 shadow-sm">
                <i class="ri-delete-bin-line mr-1"></i> {{$t('delete')}}
            </b-button>
        </div>
    </div>
</template>
<script>
import MessageService from "@/services/MessageService";
import moment from "moment";
import CkEditorInput from "@/components/elements/CkEditorInput";
import {ValidationObserver, ValidationProvider} from "vee-validate"

export default {
    props: {
        msgId: {
            type: Number,
            default: null,
        }
    },
    components: {
        CkEditorInput,
        ValidationObserver,
        ValidationProvider

    },

    data() {
        return {
            msgContent: {},
            answerMsg: null,
            msgEditorShow: false,
            user: null
        }
    },
    created() {
        this.user = this.$store.getters['auth/getUser']
    },
    watch: {
        msgId: {
            handler(value){
                if(value != null){
                    this.getMessage(value)
                }
            }
        }
    },
    methods: {
        goBack(){
            this.$emit('goBack', true)
        },

        getMessage(id){
            MessageService.showMessage(id).then(response => {
                this.msgContent = response.data.data[0]
                this.msgContent.updated_at = moment(this.msgContent.updated_at).format("DD.MM.YYYY HH:MM")
            }).catch(e => {
                this.showErrors(e, null)
            })
        },

        formatDate(date){
            return moment(date).format("DD.MM.YYYY HH:MM")
        },

        decodeHtml(html) {
            let txt = document.createElement("textarea");
            txt.innerHTML = html;
            return txt.value;
        },

        showEditor() {
            this.msgEditorShow = this.msgEditorShow ? false : true
        },

        async sendAnswer(){
            const isValid = await this.$refs.answerForm.validate();
            if (isValid) {
                let formData = {
                    parent_id: this.msgId,
                    message: this.answerMsg
                }
                MessageService.answerMessage(formData).then(response => {
                    this.$toast.success(this.$t('success_send_message'))
                    this.showEditor()
                    this.getMessage(this.msgId)
                    this.answerMsg = null
                }).catch(e => {
                    this.$toast.error(this.$t('api.'+e.data.message))
                })
            }
        },

        deleteMessage(){
            this.$swal({
                title: this.$t('attention'),
                text: this.$t('message_delete_confirm'),
                showCancelButton: true,
                confirmButtonText: this.$t('yes'),
                cancelButtonText: this.$t('no')
            }).then(response => {
                if (response.isConfirmed == true) {
                    MessageService.deleteMessage(this.msgId).then(response => {
                        this.$toast.success(this.$t('api.'+response.data.message))
                        this.$emit('goBack', true)
                    }).catch(e => {
                        this.$toast.error(this.$t('api.'+e.data.message))
                    })
                }
            })
        },

        downloadFile(obj){
            if(this.checkPermission('message_showmedia')){
                MessageService.showMedia(obj.id).then(response => {
                    this._downloadFile(response, obj.name)
                }).catch(e => {
                    this.$toast.error(this.$t('api.'+e.data.message))
                })
            } else {
                this.$toast.error(this.$t('you_are_not_authorized_for_this_operation'))
            }

        }
    }
}
</script>
<style scoped>
.attachment-card {
    transition: all 0.2s ease-in-out;
    border: 1px solid #e2e8f0 !important;
}
.attachment-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08) !important;
    border-color: #3b82f6 !important;
}
.btn-icon {
    width: 38px;
    height: 38px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.cursor-pointer {
    cursor: pointer;
}
</style>

